import type { NotificationEvent } from './send-notification';

/**
 * Décide l'événement à envoyer au prof quand un élève TERMINE un exercice.
 *
 * Renvoie `null` (donc aucune notification) si la tentative n'a pas été
 * réellement écrite côté serveur (`noWrite` = mode prévisualisation tuteur ou
 * démo anonyme) ou si l'id d'exercice manque. Sinon l'événement
 * `exercise_completed` — l'edge fn `send-notification` ne notifiera le(s)
 * prof(s) que s'il existe un assignment pour ce couple (élève, exercice).
 *
 * PUR & testé (`completion.test.ts`).
 */
export function completionNotification(
  exerciseId: string | null | undefined,
  opts: { noWrite: boolean },
): Extract<NotificationEvent, { type: 'exercise_completed' }> | null {
  if (opts.noWrite) return null;
  if (!exerciseId) return null;
  return { type: 'exercise_completed', exercise_id: exerciseId };
}
